import React from "react";

export const decorateUrl = str => {
    const pattern = new RegExp('^https?:\\/\\/');
    if (pattern.test(str)) {
        return <a href={str} target={"_blank"}>{str}</a>;
    }
    return str;
};


// WEBPACK FOOTER //
// ./src/components/results/details/utils.js